import { ApiFlexError } from '@/services/api/api-error.ts';

export function showBackEndFlexErrorMessage(title: string, error: unknown) {
  console.log('showBackEndErrorMessage:', error);
  if (error instanceof ApiFlexError) {
    alert(`${title}\n\n${error.message}`);
    return;
  }
  alert(`${title}\n\n'알 수 없는 오류가 발생하였습니다.'`);
}
